module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ei3Kq"))).then(() => module.bundle.root('lKlEc'));